import React from 'react';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TrashIcon } from 'src/components/SvgIcons';
import colors from 'src/utils/colors';

// Reusable styled TrashIcon component with flexible sizing
export const StyledTrashIcon = styled(TrashIcon)<{
  disabled?: boolean;
  width?: string;
  height?: string;
}>(({ disabled, width, height }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  color: disabled ? colors.opaqueGrey : colors.red,
  width: width ? `${width} !important` : '20px !important',
  height: height ? `${height} !important` : '20px !important',
  display: 'inline-block',
  transition: 'all 0.2s ease',
  '&:hover': {
    opacity: disabled ? 0.5 : 0.8,
    color: disabled ? colors.opaqueGrey : colors.redBright
  },
  '& svg': {
    width: width || '20px',
    height: height || '20px',
    color: 'inherit',
    stroke: 'currentColor'
  }
}));

type Props = {
  onDelete: () => void;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  tooltip?: string;
  show?: boolean;
};

function DeleteIcon({ onDelete, size = 'small', disabled = false, tooltip, show = true }: Props) {
  if (!show) {
    return null;
  }

  // Map size to actual pixel dimensions
  const sizeMap = {
    small: '16px',
    medium: '20px',
    large: '24px'
  };

  const iconSize = sizeMap[size];

  return (
    <IconButton
      size={size}
      onClick={onDelete}
      disabled={disabled}
      title={tooltip}
      sx={{
        padding: '4px',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: 'rgba(243, 83, 121, 0.1)' // Using colors.red with 10% opacity
        },
        '&:disabled': {
          opacity: 0.5
        }
      }}
    >
      <StyledTrashIcon disabled={disabled} width={iconSize} height={iconSize} />
    </IconButton>
  );
}

export default DeleteIcon;
